import type { OccasionType } from '@forbiz/contracts'

import styles from '../app.module.css'

/**
 * 리본 실물 미리보기 (BIZ-81).
 *
 * 실제 화환 리본은 한 쌍(2개)이다: 문구 리본 + 보내는 이 리본.
 * - 왼쪽 리본  = 리본 문구 1 (예: 삼가 고인의 명복을 빕니다)
 * - 오른쪽 리본 = 리본 문구 2, 비우면 발신자 (주문 규칙과 동일)
 * 각 리본 아래에 왼쪽/오른쪽 라벨을 달아 어느 칸이 어느 리본인지 눈에 매핑되게 한다.
 * 전 유형 리본으로 나간다(난·기타 포함 — 카드 메시지는 실무 미사용으로 폐기).
 *
 * 레이아웃: 그리드 2열 × 2행 — 위 행 두 리본은 같은 행 높이에 맞춰 같은 길이로,
 * 아래 행 두 라벨은 나란히. 리본 텍스트는 세로 한 줄(nowrap)로 접히지 않는다.
 *
 * 화환은 고인명·발신자 오타가 대참사라, 입력하는 그대로 실제 리본 모양으로 보여
 * 제출 전에 눈으로 잡게 한다.
 */
const OCCASION_LABEL: Record<OccasionType, string> = {
  FUNERAL: '근조',
  CELEBRATION: '축하',
  GIFT: '난·기타',
}

export function RibbonPreview({
  occasion,
  line1,
  line2,
  senderName,
}: {
  occasion: OccasionType
  line1: string
  line2: string
  senderName: string
}) {
  const label = OCCASION_LABEL[occasion]
  const phrase = line1.trim()
  const sender = line2.trim() || senderName.trim()
  const phrasePlaceholder = occasion === 'FUNERAL' ? '삼가 고인의 명복을 빕니다' : '축하합니다'
  return (
    <figure className={styles.ribbonWrap} aria-label={`${label} 리본 미리보기`}>
      <div className={styles.ribbonPair}>
        <div className={phrase ? styles.rband : `${styles.rband} ${styles.rbandEmpty}`}>
          {phrase || phrasePlaceholder}
        </div>
        <div className={sender ? styles.rband : `${styles.rband} ${styles.rbandEmpty}`}>
          {sender || '보내는 이'}
        </div>
        <span className={styles.ribbonColLabel}>왼쪽 리본 · 문구</span>
        <span className={styles.ribbonColLabel}>오른쪽 리본 · 보내는 이</span>
      </div>
    </figure>
  )
}
